import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { Button } from 'components/base';
import isProd from 'utils/isProd';
import isStaging from 'utils/isStaging';
import Environments from 'constants/Environments';
import { useOptimizeExperiment } from 'hooks/useOptimizeExperiment';

const EXPERIMENT_ID_PAGE_LOAD = '04XJX_sBTUewSRcrliMejQ';
const EXPERIMENT_ID_COMPLETION = '5849Xz3CRLihT8CdYFnyoQ';
const VARIANT_ID = '1';
const LARGE_SCREEN_SIZE_PX = 992;

let assistantHost = Environments.LOCAL.portalHost;
if (isProd()) {
  assistantHost = Environments.PRODUCTION.host;
} else if (isStaging()) {
  assistantHost = Environments.STAGING.host;
}

const EmbeddedBuoyAssistant = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [isEnabled, setIsEnabled] = useState(false);

  useOptimizeExperiment(EXPERIMENT_ID_PAGE_LOAD, (variant: string) => {
    setIsEnabled(variant === VARIANT_ID);
  });
  useOptimizeExperiment(EXPERIMENT_ID_COMPLETION, (variant: string) => {
    setIsEnabled(variant === VARIANT_ID);
  });

  useEffect(() => {
    if (window.innerWidth < LARGE_SCREEN_SIZE_PX) {
      setIsOpen(false);
    }
  }, []);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <div
        className={cx('EmbeddedBuoyAssistant__interview', {
          'EmbeddedBuoyAssistant--hide': !isOpen,
        })}
      >
        <div className={`EmbeddedBuoyAssistant__interview--top-bar`}>
          <Button
            ariaLabel="embedded-symptom-checker-close"
            className={`EmbeddedBuoyAssistant__interview--top-bar-close`}
            label="Close"
            onClick={() => setIsOpen(!isOpen)}
            variant="hover-underline-white"
          />
        </div>
        <iframe
          className={`EmbeddedBuoyAssistant__interview--iframe`}
          src={`//${assistantHost}/symptom-checker/?utm_source=content_page_iframe`}
        />
      </div>
      <Button
        ariaLabel="embedded-symptom-checker"
        className={cx('EmbeddedBuoyAssistant__button', {
          'EmbeddedBuoyAssistant--hide': isOpen,
        })}
        label="Check symptoms here!"
        onClick={() => setIsOpen(!isOpen)}
        variant="primary"
      />
    </>
  );
};

export default EmbeddedBuoyAssistant;
